import { ItemGroupDeletedEvent } from '@rematter/frontend-lib-api-client/grpc/inventory/v1/item_group_events_pb';
import { Col, FieldDisplay, IDField } from '@rematter/ui-web';

type ItemGroupDeletedDetailProps = {
  event: ItemGroupDeletedEvent;
};

export const ItemGroupDeletedDetail = ({
  event,
}: ItemGroupDeletedDetailProps) => {
  const itemGroup = event.itemGroup;

  if (!itemGroup) {
    return (
      <Col className="@ItemGroupDeletedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  return (
    <Col className="@ItemGroupDeletedDetail gap-3" gap3>
      <Col
        className="rounded-md border border-failure/20 bg-failure/5 p-3"
        gap2
      >
        <span className="text-xs font-medium text-failure/80">
          Deleted Item Group
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={itemGroup.id?.value} />
          <FieldDisplay label="Name" value={itemGroup.name} />
          <FieldDisplay label="Number" value={itemGroup.number} />
          <IDField label="Parent ID" value={itemGroup.parentId?.value} />
          <FieldDisplay label="Description" value={itemGroup.description} />
        </div>
      </Col>
    </Col>
  );
};
